module.exports = __webpack_public_path__ + "static/media/iphone_12_blue.ba7d6a16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_12_blue.png
// module id = 2089
// module chunks = 0